/**
 * LastPatientCard — newest patient (name + created date, no other PII).
 */

import { UserPlus } from "@phosphor-icons/react";
import { getRelativeDate } from "../../shared/nivDerived";
import { formatDateTime } from "../clinicDetailConstants";
import { Block } from "./Skeletons";

export default function LastPatientCard({ lastPatient, isLoading, totalPatients, activePatients }) {
  const name = lastPatient ? `${lastPatient.firstName} ${lastPatient.lastName}`.trim() || "ללא שם" : null;
  return (
    <section className="ncd2-card ncd2-last-patient">
      <header className="ncd2-card-head">
        <span className="ncd2-card-icon">
          <UserPlus size={15} weight="bold" />
        </span>
        <div className="ncd2-card-titles">
          <span className="ncd2-card-eyebrow">מטופל אחרון שנוסף</span>
          <h3 className="ncd2-card-title">
            {isLoading ? <Block w={120} h={14} /> : name || "אין מטופלים עדיין"}
          </h3>
        </div>
      </header>
      {!isLoading && lastPatient && (
        <div className="ncd2-last-patient-meta">
          <strong>{getRelativeDate(lastPatient.createdAt)}</strong>
          <span className="ncd2-muted">{formatDateTime(lastPatient.createdAt)}</span>
          {lastPatient.isActive === false && <span className="ncd2-badge ncd2-badge-muted">לא פעיל</span>}
        </div>
      )}
      {!isLoading && (
        <div className="ncd2-last-patient-foot">
          <span>
            סה"כ <strong>{totalPatients ?? 0}</strong> מטופלים
          </span>
          <span className="ncd2-muted">{activePatients ?? 0} פעילים</span>
        </div>
      )}
    </section>
  );
}
